import Icon from '../components/Icon.vue'

Icon.register({
  'window-minimize': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 352c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/window-minimize.js
// module id = 2111
// module chunks = 0